import { InputSwitch } from '@repo/atomic-components';
import type { InputSwitchChangeEvent } from '@repo/atomic-components';
import { setTextPreferences, useTextPreferences } from '@/ui/theme/textPreferences';
import type { Font, TextSize } from '@/ui/theme/textPreferences';
import { SegmentedControl } from '../SegmentedControl';
import type { SettingControlProps } from '../types';

const TEXT_SIZE_OPTIONS: readonly { value: TextSize; label: string }[] = [
  { value: 'small', label: 'Small' },
  { value: 'default', label: 'Default' },
  { value: 'large', label: 'Large' },
  { value: 'extra-large', label: 'Extra large' },
];

/** Each option is set in its own font, so the choice previews itself. */
const FONT_OPTIONS: readonly { value: Font; label: string; className: string }[] = [
  { value: 'default', label: 'Default', className: 'font-default' },
  { value: 'verdana', label: 'Verdana', className: 'font-verdana' },
  { value: 'open-dyslexic', label: 'OpenDyslexic', className: 'font-open-dyslexic' },
];

const setTextSize = (textSize: TextSize) => setTextPreferences({ textSize });
const setFont = (font: Font) => setTextPreferences({ font });

export const TextSizeControl = ({ labelId }: SettingControlProps) => {
  const { textSize } = useTextPreferences();

  return <SegmentedControl labelId={labelId} options={TEXT_SIZE_OPTIONS} value={textSize} onChange={setTextSize} />;
};

export const FontControl = ({ labelId }: SettingControlProps) => {
  const { font } = useTextPreferences();

  return <SegmentedControl labelId={labelId} options={FONT_OPTIONS} value={font} onChange={setFont} />;
};

export const LineSpacingControl = ({ labelId }: SettingControlProps) => {
  const { increasedLineSpacing } = useTextPreferences();

  const handleChange = (event: InputSwitchChangeEvent) =>
    setTextPreferences({ increasedLineSpacing: Boolean(event.value) });

  return <InputSwitch checked={increasedLineSpacing} onChange={handleChange} aria-labelledby={labelId} />;
};
